import React from "react";
import "./NotesDisplayer.css";

import { noteTemplate } from "../Templates/noteTemplate";
import CreatedNoteBlock from "./CreatedNoteBlock/CreatedNoteBlock";

function NotesDisplayer(props: {notesData: Map<number, noteTemplate>, noteButtonWasClicked: (noteInfo: noteTemplate, key: number) => void}): JSX.Element {
    const mapOfCreatedNoteBlocks = new Map<Date, React.ReactElement>();
    const arrayOfDatesForCreatedNoteBlocks = new Array<Date>();
    const arrayOfCreatedNoteBlocks = new Array<React.ReactElement>();

    props.notesData.forEach((template: noteTemplate, key: number) => {
        mapOfCreatedNoteBlocks.set(template["Date Created"], <CreatedNoteBlock key={key} id={key.toString()} noteInfo={template} wasClicked={props.noteButtonWasClicked} keyOfTemplate={key}/>)
    })

    mapOfCreatedNoteBlocks.forEach((element: React.ReactElement, date: Date) => {
        arrayOfDatesForCreatedNoteBlocks.push(date);
    })

    arrayOfDatesForCreatedNoteBlocks.sort((d1: Date, d2: Date) => d2.getTime() - d1.getTime()); // Should be sorted from most recent to least recent

    arrayOfDatesForCreatedNoteBlocks.forEach((date: Date) => {
        arrayOfCreatedNoteBlocks.push(mapOfCreatedNoteBlocks.get(date) as React.ReactElement);
    })

    return (
        <div className="notesDisplayer">
            <div className="noteBlockHeader">
                <div className="noteBlockHeader_titleSection">
                    <h2 className="noteBlockHeader_TitleArea"><i>Title</i></h2>
                </div>

                <div className="noteBlockHeader_noteSection">
                    <h2 className="noteBlockHeader_ContentArea"><i>Content</i></h2>
                </div>

                <div className="noteBlockHeader_dateSection">
                    <h2 className="noteBlockHeader_DateArea"><i>Last Modified</i></h2>
                </div>
            </div>

            {arrayOfCreatedNoteBlocks}
        </div>
    )
}

export default NotesDisplayer;